import Component from 'vue-class-component'
import Vue from 'vue'
import ConvoComment from './ConvoComment.vue'
import convoStore from '../../store/convo/convo-store'
import SaveButton from '@/components/buttons/SaveButton.vue'
import authStore from '@/store/auth/auth-store';
import LoginButton from '@/components/buttons/LoginButton';

@Component({
  name: 'convoComments',
  props: ['convo'],
  components: {
    'login-button': LoginButton,
    'convo-comment' : ConvoComment,
    'save-button': SaveButton
  }
})
export default class ConvoComments extends Vue {

  get isAuthenticated():boolean {return authStore.isAuthenticated}

  protected addConvoComment (): void {
    convoStore.dispatchAddComment(this.$props['convo'])
  }

  protected removeConvoComment (comment: string): void {
  /*
  convoStore.dispatchRemoveComment({ convo: this.$props['convo'], comment: comment })
  */
  }

  protected addStatements (): void {
    convoStore.dispatchEditCommentStatements(this.$props['convo'])
  }
}
